import {Injectable} from '@angular/core';
import {FundPerformanceResourceApi} from "./api/fund-performance-resource.api";

@Injectable()
export class FundPerformanceResourceService {

  constructor(private fundPerformanceResourceApi: FundPerformanceResourceApi) {
  }

  getHistory(searchString, fromDate, toDate, currentlanguage) {
    return this.fundPerformanceResourceApi.getHistory(searchString, fromDate, toDate, currentlanguage);
  }
}
